(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('chatSettingsCtrl', ['$scope', '$state', '$rootScope', '$stateParams', '$uibModal', 'jwtService', 'teamSettingsService', 'usersService', 'growlService',
            function ($scope, $state, $rootScope, $stateParams, $uibModal, jwtService, teamSettingsService, usersService, growlService) {
                $scope.id = $stateParams.pickedApiSpaceId;
                $scope.accountId = jwtService.payload.accountId;

                $scope.$on('MembersCountChange', function (event, message) {
                    if ($scope.teams) {
                        var modifiedTeam = $scope.teams.find(function (team) {
                            return team.id == message.teamId;
                        });
                        modifiedTeam.members = message.members;
                    }
                });

                $scope.$on("teamNameChanged", function (event, message) {
                    if ($scope.teams) {
                        var modifiedTeam = $scope.teams.find(function (team) {
                            return team.id == message.teamId;
                        });
                        modifiedTeam.name = message.teamName;
                    }
                });

                $scope.$on('ChannelsCountChange', function (event, message) {
                    getChatConfig();
                });

                $scope.$on('WorkingHoursChange', function (event, message) {
                    processConfig(message);
                });

                $scope.channels = {
                    sms: {
                        link: "main.apiSpace.chat2.settings.team.config({channel:'sms'})"
                    },
                    fbMessenger: {
                        link: "main.apiSpace.chat2.settings.team.config({channel:'fbMessenger'})"
                    },
                    appMessaging: {
                        link: "main.apiSpace.chat2.settings.team.config({channel:'appMessaging'})"
                    },
                    email: {
                        link: "main.apiSpace.chat2.settings.team.config({channel:'email'})"
                    }

                };



                $scope.isTeamSelected = false;

                getTeams($scope.id);

                function getTeams(id) {
                    teamSettingsService.getTeams(id)
                        .then(processTeams)
                        .catch(processTeamsErrors);
                }

                var users;

                function isInUsers(member) {
                    return (_.findIndex(users, function (el) {
                        return el.userName === member.username;
                    }) != -1);
                }

                function processTeams(data) {
                    $scope.teams = data;
                    $scope.noTeam = ($scope.teams.length === 0);
                    $scope.isTeamSelected = !$scope.noTeam;
                    if (!$scope.noTeam) {
                        $state.go('main.apiSpace.chat2.settings.team', { teamId: $scope.teams[0].id });
                    }
                    usersService.getUsers($scope.accountId).then(
                        function (data) {
                            users = data;
                            $scope.teams.forEach(function (team) {
                                if (team.members && team.members.length > 0) {
                                    team.members = team.members.filter(isInUsers);
                                }
                            });
                        });

                    getChatConfig();
                }

                function getChatConfig() {
                    teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId)
                        .then(processConfig)
                        .catch(
                            function (error) {
                                if (error.status && error.status === 404) {
                                    processConfig('noConfig');
                                } else {
                                    processConfigErrors(error);
                                }
                            }
                        );

                }

                function processConfig(data) {

                    if (data !== 'noConfig' && data.teams) {
                        data.teams.forEach(function (team) {
                            var foundedTeam = $scope.teams.find(function (el) {
                                return el.id === team.teamId;
                            });
                            if (foundedTeam) {

                                if (team.channels) {
                                    foundedTeam.channels = Object.keys(team.channels);
                                }
                                if (team.settings && team.settings.avatarUrl && team.settings.avatarUrl.length > 0) {
                                    foundedTeam.avatarUrl = team.settings.avatarUrl;
                                } else {
                                    foundedTeam.avatarUrl = "assets/img/icons/profile_image.png";
                                }

                                if (team.settings && team.settings.workingHours && team.settings.workingHours.length > 0) {
                                    foundedTeam.outOfHours = true;
                                } else {
                                    foundedTeam.outOfHours = false;
                                }
                            }

                        });
                    }
                }

                function processTeamsErrors(error) {
                    growlService.danger("Teams data was not available, due to: " + error.statusText);
                }

                $scope.processTeamsErrors = processTeamsErrors;

                function processConfigErrors(error) {
                    if (error) {
                        growlService.danger("Teams channels data was not available, due to: " + error.statusText);
                    }

                }

                $scope.addTeam = function () {

                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/chat/templates/addTeamModal.html',
                        controller: 'addTeamModal',
                        resolve: {
                            id: function () {
                                return $scope.id;
                            }
                        }
                    });

                    modalInstance.result.then(function (newTeam) {
                        if (!$scope.teams) {
                            $scope.teams = [];
                        }
                        $scope.teams.push(newTeam);
                        $scope.noTeam = false;
                        $state.go('main.apiSpace.chat2.settings.team', { teamId: newTeam.id });
                    }, function (error) {

                    });
                };
                $scope.processConfig = processConfig;
                $scope.getChatConfig = getChatConfig;

            }]);

})(window.angular);